import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LoadService } from 'src/app/core/services/load.service';
import { SesionService } from 'src/app/core/services/sesion.service';
import { fieldsMatchValidator, validatorAmountRange } from '../../validators/custom-validator';
import { BrokerService } from 'src/app/core/services/broker.service';
import { OfferService } from 'src/app/core/services/offer.service';
import { CookieService } from 'ngx-cookie-service';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { Router } from '@angular/router';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';

@Component({
    selector: 'app-bc-conecta-wasticredit',
    templateUrl: './bc-conecta-wasticredit.component.html',
    styleUrls: ['./bc-conecta-wasticredit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BcConectaWasticreditComponent implements OnInit {

  listBanks = [
    { label: 'BANCO DE BOGOTÁ', value: 'BANCO DE BOGOTÁ' },
    { label: 'BANCO POPULAR', value: 'BANCO POPULAR' },
    { label: 'ITAÚ', value: 'ITAÚ' },
    { label: 'BANCOLOMBIA', value: 'BANCOLOMBIA' },
    { label: 'BANCO GNB SUDAMERIS', value: 'BANCO GNB SUDAMERIS' },
    { label: 'BBVA COLOMBIA', value: 'BBVA COLOMBIA' },
    { label: 'BANCO COLPATRIA', value: 'BANCO COLPATRIA' },
    { label: 'SCOTIABANK', value: 'SCOTIABANK' },
    { label: 'BANCO DE OCCIDENTE', value: 'BANCO DE OCCIDENTE' },
    { label: 'BANCO CAJA SOCIAL', value: 'BANCO CAJA SOCIAL' },
    { label: 'BANCO AGRARIO', value: 'BANCO AGRARIO' },
    { label: 'BANCO DAVIVIENDA S.A.', value: 'BANCO DAVIVIENDA S.A.' },
    { label: 'BANCO AV VILLAS', value: 'BANCO AV VILLAS' },
    { label: 'BANCO PROCREDIT', value: 'BANCO PROCREDIT' },
    { label: 'BANCO PICHINCHA S.A.', value: 'BANCO PICHINCHA S.A.' },
    { label: 'BANCOOMEVA', value: 'BANCOOMEVA' },
  ];

  listIncomeSource = [
    { label: 'Estudiante', value: 'Estudiante' },
    { label: 'Pensionado', value: 'Pensionado' },
    { label: 'Desempleado', value: 'Desempleado' },
    { label: 'Comerciante independiente', value: 'Comerciante independiente' },
    { label: 'Empleado a término fijo', value: 'Empleado a término fijo' },
    { label: 'Empleado a término indefinido', value: 'Empleado a término indefinido' },
    { label: 'Contratista por prestación de servicios', value: 'Contratista por prestación de servicios' },
  ];

  listAccountType = [
    { label: 'Ahorros', value: 'Cuenta Ahorros' },
    { label: 'Corriente', value: 'Cuenta Corriente' },
  ];

  listAddressStreetType = [
    { label: 'Via', value: 'Via' },
    { label: 'Calle', value: 'Calle' },
    { label: 'Avenida', value: 'Avenida' },
    { label: 'Carrera', value: 'Carrera' },
    { label: 'Manzana', value: 'Manzana' },
    { label: 'Circular', value: 'Circular' },
    { label: 'Diagonal', value: 'Diagonal' },
    { label: 'Circunvalar', value: 'Circunvalar' },
    { label: 'Transversal', value: 'Transversal' },
    { label: 'Avenida Calle', value: 'Avenida Calle' },
    { label: 'Avenida Carrera', value: 'Avenida Carrera' },
  ];

  resultContent: boolean = false;
  correctAmount: boolean = false;
  success: boolean = false;
  refused: boolean = false;
  termOptionsSPay: number[] = [14, 30];
  termOptionIPrd: number[] = [3];

  offerInfo: any;
  listFiltroBanks: any = [];
  currentStep = 1;
  amountRequired: string = '';
  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  threeFormGroup: UntypedFormGroup;
  range: number[] = [0, 0];
  selectProduct: any = {};
  redirectUrlWasticredit: string = '';
  selectedTerm: number | null = null;
  valorIncome: string = '';
  valorAmount: string = '';
  maxDate: Date = new Date(); // Fecha máxima: hoy
  selectIncomeSource = { value: "", label: "" };
  selectBank = { value: "", label: "" };
  selectAccountType = { value: "", label: "" };

  constructor(
    public load: LoadService,
    private formBuilder: UntypedFormBuilder,
    public sesion: SesionService,
    public broker: BrokerService,
    public offer: OfferService,
    private cookieService: CookieService,
    public utilities: UtilitiesService,
    public router: Router,
  ) {
    this.firstFormGroup = this.formBuilder.group({
      bankAccountType: ['', [Validators.required]],
      incomeSource: ['', [Validators.required]],
      accountType: ['', [Validators.required]],
      bankAccountNumber: ['', [Validators.required]],
      confirmBankAccountNumber: ['', [Validators.required]],
      birthDate: ['', [Validators.required]],
    }, {
      validators: fieldsMatchValidator('bankAccountNumber', 'confirmBankAccountNumber')
    });

    this.secondFormGroup = this.formBuilder.group({
      addressStreetType: ['', [Validators.required]],
      addressStreet: ['', [Validators.required]],
      addressStreetSecondaryNumber: ['', [Validators.required]],
      addressStreetComplementNumber: ['', [Validators.required]],
      alternativePhone: ['', [Validators.required, Validators.minLength(10), Validators.pattern(/^(?!.*(\d)\1{3,})3\d*$/)]],
      tyc: ['', [Validators.requiredTrue]]
    })

    this.threeFormGroup = this.formBuilder.group({
      typeProduct: ['', [Validators.required]],
      amount: ['', [Validators.required]],
      term: ['', [Validators.required]],
      income: ['', [Validators.required]],
    },
      {
        validators: validatorAmountRange(this.range, 'amount')
      })

  }

  ngOnInit(): void {
  }
  
  applyOffer() {

    this.load.isInProcess = true;
    let sourceOfTraffic = '';
    let campaignOfTraffic = '';
    let mediumOfTraffic = '';
    if ((Object.keys(this.utilities.utmParams).length > 0)) {
      for (const key in this.utilities.utmParams) {
        if (key.toLowerCase() == 'utm_source') {
          sourceOfTraffic = this.utilities.utmParams[key]
        }
        if (key.toLowerCase() == 'utm_medium') {
          mediumOfTraffic = this.utilities.utmParams[key]
        }
        if (key.toLowerCase() == 'utm_campaign') {
          campaignOfTraffic = this.utilities.utmParams[key]
        }
      }
    }
    let amount = this.threeFormGroup.get('amount')?.value;
    amount = amount.split('.').join('');
    let request = {
      idSession: this.cookieService.get('IDSESSIONMDC'),
      companyId: this.offer.offerSelected.company.id,
      offerId: this.offer.offerSelected.offerId,
      amount: amount,
      sourceOfTraffic: sourceOfTraffic,
      campaignOfTraffic: campaignOfTraffic,
      mediumOfTraffic: mediumOfTraffic,
      conecta: {
        incomeSource: this.firstFormGroup.get('incomeSource')?.value,
        bank: this.firstFormGroup.get('accountType')?.value,
        bankAccountType: this.firstFormGroup.get('bankAccountType')?.value,
        bankAccountNumber: this.firstFormGroup.get('bankAccountNumber')?.value,
        addressStreet: this.secondFormGroup.get('addressStreet')?.value,
        addressStreetSecondaryNumber: this.secondFormGroup.get('addressStreetSecondaryNumber')?.value,
        addressStreetComplementNumber: this.secondFormGroup.get('addressStreetComplementNumber')?.value,
        alternativePhone: this.secondFormGroup.get('alternativePhone')?.value,
        addressStreetType: this.secondFormGroup.get('addressStreetType')?.value,
        productId: this.threeFormGroup.get('productId')?.value,
        amount: amount.toString(),
        term: this.threeFormGroup.get('term')?.value,
        typeProduct: this.threeFormGroup.get('typeProduct')?.value
      }
    }

    this.broker.aplicarOferta(request).subscribe({
      next: (result: any) => {   
          // Validar si data es null
          if (result.responseConecta.data === null || result.responseConecta.data === undefined) {
            this.success = false;
            this.refused = false;
            this.resultContent = true;
            this.load.isInProcess = false;
            this.load.isConectaFail = true;
            this.load.isConectaRejected = false;
            this.load.imgBcConectaDesktop = this.load.imgsBcConecta.d_fail;
            this.load.imgBcConectaMobile = this.load.imgsBcConecta.m_fail;
            return;
          }
          const dataObj = typeof result.responseConecta.data === 'string' ? JSON.parse(result.responseConecta.data) : result.responseConecta.data;
          // El status y redirectUrl están anidados en dataObj.data
          const statusData = dataObj.data || dataObj;
          const status = statusData.status;
          
          //Pre-aprobado
          if (status === "PRE_APPROVED") {
            this.success = true;
            this.offerInfo = statusData;
            this.resultContent = true;
            // Usar redirectUrl del statusData
            this.redirectUrlWasticredit = statusData.redirectUrl || result.responseConecta.redirectUrl || '';
            this.load.isInProcess = false;
          } else if (status === "NOT_APPROVED" || status === "REJECTED") {
            // Rechazo por políticas crediticias
            this.refused = true;
            this.failProcess(this.refused);
          } else {
            // Status desconocido o error técnico
            this.success = false;
            this.refused = false;
            this.resultContent = true;
            this.load.isInProcess = false;
            this.load.isConectaFail = true;
            this.load.isConectaRejected = false;
            this.load.imgBcConectaDesktop = this.load.imgsBcConecta.d_fail;
            this.load.imgBcConectaMobile = this.load.imgsBcConecta.m_fail;
          }
      },
      error: (error: any) => {
        this.failProcess();
        console.error(error);
      }
    });
    
  }

  nextStep(step: number = 0) {
        
    if (step > 0) {
      this.currentStep = step;
    } else {
      this.currentStep++;
    }
    if (this.currentStep === 3) {
      this.updateInfo();
    }
  }

  returnStep() {
    this.currentStep--;
  }

  setRange(type: boolean, term: number) {
    this.selectedTerm = term;
    this.threeFormGroup.get('term')?.setValue(term);
    if (type) {
      this.threeFormGroup.get('typeProduct')?.setValue("singlePayProduct");
      this.range = [300000, 1000000]
    } else {
      this.threeFormGroup.get('typeProduct')?.setValue("installmentProducts");
      this.range = [300000, 2000000]
    }
    this.threeFormGroup.setValidators(validatorAmountRange(this.range, 'amount'));
    this.threeFormGroup.updateValueAndValidity();
  }

  onInputChangeIncome(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\./g, '').replace(/\D/g, '');
    this.valorIncome = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    this.threeFormGroup.get('income')?.setValue(value);
  }

  onInputChangeAmount(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\./g, '').replace(/\D/g, '');
    this.valorAmount = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    this.threeFormGroup.get('amount')?.setValue(value);
  }

  returnConfirmTelephone() {
    this.load.closeBcConecta();
    this.sesion.confirmTelephoneConecta = true;
    this.sesion.stepConfirmTelephone = 1;
    setTimeout(() => {
      this.load.openNotValidateSoftFilters('#confirmationModalV2', '', '', false, undefined);
    }, 300)
  }

  setValueBank(event: any) {
    this.firstFormGroup.get('accountType')?.setValue(event.value);
    this.selectBank = event;
  }

  setValueAccountType(event: any) {
    this.firstFormGroup.get('bankAccountType')?.setValue(event.value);
    this.selectAccountType = event;
  }

  setValueIncomeSource(event: any) {
    this.firstFormGroup.get('incomeSource')?.setValue(event.value);
    this.selectIncomeSource = event;
  }

  setValueAddressStreetType(event: any) {
    this.secondFormGroup.get('addressStreetType')?.setValue(event.value);
  }

  formatBirthDateInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');
    
    if (value.length >= 2) {
      value = value.substring(0, 2) + '/' + value.substring(2);
    }
    if (value.length >= 5) {
      value = value.substring(0, 5) + '/' + value.substring(5, 9);
    }
    
    input.value = value;
    
    if (value.length === 10) {
      const parts = value.split('/');
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);
      
      const date = new Date(year, month, day);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (date.getFullYear() === year && date.getMonth() === month && date.getDate() === day && date <= today) {
        this.firstFormGroup.get('birthDate')?.setValue(date);
      } else if (date > today) {
        this.firstFormGroup.get('birthDate')?.setValue(null);
        input.value = '';
      }
    }
  }

  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    const date = event.value;
    if (date) {
      this.firstFormGroup.get('birthDate')?.setValue(date);
    }
  }
  month( m:any ) {
    return ((m.getMonth()+1) < 10 ? '0' : '') + (m.getMonth()+1);
  }
  day( d:any ) {
    return (d.getDate() < 10 ? '0' : '') + d.getDate();
  }

  /**
  * Funcion para manejar el flujo de error/rechazo al moemento de aplicar una oferta en conecta
  * @param isRejected parametro para saber si la oferta fue rechazada o fallo otro consumo del servicio
  */
  failProcess(isRejected: boolean = false) {
    this.load.isInProcess = false;
    this.resultContent = true;
    //this.activeModalProcessRequest = true;
    this.currentStep = 0;
    this.success = false;
    this.load.isInProcess = false;
    this.load.isConectaFail = true;
    this.load.isConectaRejected = isRejected;
    this.load.imgBcConectaDesktop = this.load.imgsBcConecta.d_fail;
    this.load.imgBcConectaMobile = this.load.imgsBcConecta.m_fail;
    if (isRejected) {
      // Limpiar inmediatamente las listas y localStorage
      this.offer.offersList = this.offer.offersList.filter((ele: any) => ele.idOffer != this.offer.offerSelected.idOffer);
      this.offer.offersFil = this.offer.offersFil.filter((ele: any) => ele.idOffer != this.offer.offerSelected.idOffer);
      this.offer.clearOfferlocalStorage();

      setTimeout(() => {
        if (this.load.isConectaFail) {
          let categorySel = this.offer.categoriesActive.find((element: any) =>{ 
            return element.id == this.offer.offerSelected.detail.categoryId 
          });
          this.offer.offerSelected = undefined;
          this.load.isConectaFail = false;
          this.load.isConectaRejected = false;
          this.load.closeBcConecta();
          this.router.navigate(['/ofertas/' + categorySel.url]);
        }
      }, 15000);
    }
  }

  redirectToOffers() {
    let categorySel = this.offer.categoriesActive.find((element: any) => { 
      return element.id == this.offer.offerSelected.detail.categoryId 
    });
    
    // Limpiar estados
    this.offer.offerSelected = undefined;
    this.load.isConectaFail = false;
    this.load.isConectaRejected = false;
    
    // Cerrar modal
    this.load.closeBcConecta();
    
    
    const targetUrl = '/ofertas/' + categorySel.url;
    window.location.href = targetUrl;
  }

  redirectWasticredit() {
    window.open(this.redirectUrlWasticredit, '_self');
    this.load.closeBcConecta();
  }

  updateInfo(){

    const birthDateValue = this.firstFormGroup.get('birthDate')?.value;
    const birthDateTimestamp = birthDateValue instanceof Date ? birthDateValue.getTime() : birthDateValue;

    let bodyUpdateProfile = {
      idSession: this.cookieService.get('IDSESSIONMDC'),
      monthlyIncome: this.threeFormGroup.get('income')?.value,
      birthDate: birthDateTimestamp,
      country: "CO"
    }

    this.broker.updateInfo(bodyUpdateProfile).subscribe({
    next: (result: any) => {
    },
    error: (error: any) => {
      console.error("*** Error al actualizar el perfil!!");
      console.error(error);
    }
  });

  }

}
